
    <div class="community-sec">
        <div class="landing-container join-outer">
            <h3 class="heading">
                Join our Community
            </h3>
            <div class="about-map-box">
                <div class="box">
                    <div class="svg-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.2812 8C13.2812 10.9168 10.9168 13.2812 8 13.2812C5.08325 13.2812 2.71875 10.9168 2.71875 8C2.71875 5.08325 5.08325 2.71875 8 2.71875C10.9168 2.71875 13.2812 5.08325 13.2812 8Z"
                                fill="white" />
                            <path
                                d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM7.93933 10.2793C7.68891 10.5277 7.35033 10.6667 6.99765 10.6661C6.64496 10.6655 6.30688 10.5252 6.05733 10.276L4.20267 8.47867L5.13133 7.52067L6.99333 9.32533L10.866 5.52467L11.802 6.47467L7.93933 10.2793Z"
                                fill="#C16725" />
                        </svg>
                    </div>
                    <p class="text">
                        Coming soon - {{comingSoonCount}}
                    </p>
                </div>
        
                <div class="box">
                    <div class="svg-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.2812 8C13.2812 10.9168 10.9168 13.2812 8 13.2812C5.08325 13.2812 2.71875 10.9168 2.71875 8C2.71875 5.08325 5.08325 2.71875 8 2.71875C10.9168 2.71875 13.2812 5.08325 13.2812 8Z"
                                fill="white" />
                            <path
                                d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM7.93933 10.2793C7.68891 10.5277 7.35033 10.6667 6.99765 10.6661C6.64496 10.6655 6.30688 10.5252 6.05733 10.276L4.20267 8.47867L5.13133 7.52067L6.99333 9.32533L10.866 5.52467L11.802 6.47467L7.93933 10.2793Z"
                                fill="#2AA571" />
                        </svg>
                    </div>
                    <p class="text">
                        Available - {{availableCount}}
                    </p>
                </div>
            </div>
        
        </div>
    
    </div>

<div #mapContainer class="custom-map"></div>
